import React from 'react';

export default (props) => {
    return (
        <div className="menu-item" {...props}>
          {props.children}
        </div>
    );
};
